"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENGAGE_VIEWERS_START_TIME = exports.GET_STARTED_VIDEO = exports.ENGAGE_VIEWERS_VIDEO = void 0;
exports.ENGAGE_VIEWERS_VIDEO = '895942766';
exports.GET_STARTED_VIDEO = '895955523';
exports.ENGAGE_VIEWERS_START_TIME = 64;
